/**
 * Bottom-left "powered by Olloport" branding mark — link to olloport.com.
 * Ported from webpages/viewer/src/ui/UIManager.ts addBranding().
 */

export interface BrandingOptions {
    parent: HTMLElement;
    /** Embed mode: slightly higher opacity since the host page is whitelabeled. */
    embed?: boolean;
}

export class Branding {

    private root: HTMLAnchorElement;

    constructor({ parent, embed = false }: BrandingOptions) {
        this.root = document.createElement('a');
        this.root.className = 'ollo-branding';
        if (embed) this.root.classList.add('ollo-branding--embed');
        this.root.href = 'https://olloport.com';
        this.root.target = '_blank';
        this.root.rel = 'noopener noreferrer';

        const label = document.createElement('span');
        label.className = 'ollo-branding-label';
        label.textContent = 'powered by';

        const logo = document.createElement('img');
        logo.className = 'ollo-branding-logo';
        // BASE_URL, not '/': the viewer can be deployed under a subpath
        // (preview co-hosting uses --base=/viewer/).
        logo.src = `${import.meta.env.BASE_URL}logo.svg`;
        logo.alt = 'Olloport';

        this.root.appendChild(label);
        this.root.appendChild(logo);
        parent.appendChild(this.root);
    }

    dispose(): void {
        this.root.remove();
    }
}
